export default __webpack_public_path__ + "static/media/easySix.9e566b89.png";